import axios from "axios";

import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "./../Config/Config";
import { getUserDetails } from "../utils/userDetailsUtils";
export const AddProductAPI = async (productname) => {
  const userDetails = localStorage.getItem("userDetail");
  const temp = JSON.parse(userDetails);
  const Response = await axios
    .get(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=addproduct&companyid=${temp.companyid}&productname=${productname}`,
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error.response.data.error);
    });
  return Response;
};

export const AddCompanyURLAPI = async (companyurl) => {
  const userDetails = localStorage.getItem("userDetail");
  const temp = JSON.parse(userDetails);
  const Response = await axios
    .get(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=setcompanyurl&companyid=${temp.companyid}&companyurl=${companyurl}`,
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error.response.data.error);
    });
  return Response;
};

export const setCompanyresolutionAPI = async (resolutions, prod) => {
  const userDetails = JSON.parse(localStorage.getItem("userDetail"));
  const params = new URLSearchParams();

  params.append("webWidth", resolutions.webWidth);
  params.append("webHeight", resolutions.webHeight);
  params.append("mobileWidth", resolutions.mobileWidth);
  params.append("mobileHeight", resolutions.mobileHeight);

  return axios
    .post(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=onSubmitres&product=${prod}`,
      params,
      {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      },
    )
    .then((res) => res)
    .catch((err) => {
      console.log(err?.response?.data?.error);
    });
};

export const geturlsAPI = async (prod) => {
  const userDetails = JSON.parse(localStorage.getItem("userDetail"));

  return axios
    .get(`${API_BASE_PATH}${API_BASE_RELATIVE_PATH}`, {
      params: {
        action: "geturlsAPI",
        product: prod,
      },
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    })
    .then((res) => res)
    .catch((err) => {
      console.log(err?.response?.data?.error);
    });
};

export const getresolutionAPI = async (prod) => {
  const userDetails = JSON.parse(localStorage.getItem("userDetail"));
  return axios
    .get(`${API_BASE_PATH}${API_BASE_RELATIVE_PATH}`, {
      params: {
        action: "getresolutionAPI",
        product: prod,
      },
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    })
    .then((res) => res)
    .catch((err) => {
      console.log(err?.response?.data?.error);
    });
};
export const setnewenvAPI = async (url, product) => {
  const userDetails = JSON.parse(localStorage.getItem("userDetail"));
  const params = new URLSearchParams();

  params.append("newres", url);

  return axios.post(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=setnewenvAPI&product=${product}`,
    params,
    {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    },
  );
};

export const setCompanyURLAPI = async (urls, prod) => {
  const userDetails = JSON.parse(localStorage.getItem("userDetail"));
  const params = new URLSearchParams();

  params.append("urls", JSON.stringify(urls));

  return axios
    .post(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=onSubmiturl&product=${prod}`,
      params,
      {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      },
    )
    .then((res) => res)
    .catch((err) => {
      console.log(err?.response?.data?.error);
    });
};

export const AddModuleAPI = async (id, modulename) => {
  const userDetails = localStorage.getItem("userDetail");
  const temp = JSON.parse(userDetails);
  const Response = await axios
    .get(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=addmodule&companyid=${temp.companyid}&prodid=${id}&modulename=${modulename}`,
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error.response.data.error);
    });
  return Response;
};

export const sendResolutionaddURL = async (data) => {
  const userDetails = localStorage.getItem("userDetail");
  const temp = JSON.parse(userDetails);
  const Response = await axios
    .post(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=addURL&companyid=${temp.companyid}`,
      data,
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error.response.data.error);
    });
  return Response;
};
export const sendResolutionaddResolution = async (data) => {
  const userDetails = localStorage.getItem("userDetail");
  const temp = JSON.parse(userDetails);
  const Response = await axios
    .post(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=addResolution&companyid=${temp.companyid}`,
      data,
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error.response.data.error);
    });
  return Response;
};
export const sendResolutionaddCredential = async (data) => {
  const userDetails = localStorage.getItem("userDetail");
  const temp = JSON.parse(userDetails);
  const Response = await axios
    .post(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=addCredential&companyid=${temp.companyid}`,
      data,
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error.response.data.error);
    });
  return Response;
};

export const sendResolutionExecute = async (data) => {
  const userDetails = localStorage.getItem("userDetail");
  const temp = JSON.parse(userDetails);
  const Response = await axios
    .post(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=executeURL&companyid=${temp.companyid}`,
      data,
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error.response.data.error);
    });
  return Response;
};

export const getResolution = async (id) => {
  const userDetails = localStorage.getItem("userDetail");
  const temp = JSON.parse(userDetails);
  const Response = await axios
    .get(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getData&companyid=${temp.companyid}&productid=${id}`,
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error.response.data.error);
    });
  return Response;
};

export const addEmailCredentialApi = async (data) => {
  const userDetails = localStorage.getItem("userDetail");
  const temp = JSON.parse(userDetails);
  const Response = await axios
    .post(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=setEmailDetails&companyid=${temp.companyid}`,
      data,
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error.response.data.error);
    });
  return Response;
};
export const addDbCredentialApi = async (data) => {
  const userDetails = localStorage.getItem("userDetail");
  const temp = JSON.parse(userDetails);
  const Response = await axios
    .post(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=setDbDetails&companyid=${temp.companyid}`,
      data,
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error.response.data.error);
    });
  return Response;
};
export const fetchEmailCredentialDetails = async (api_input) => {
  const userDetails = localStorage.getItem("userDetail");
  const temp = JSON.parse(userDetails);

  const Response = await axios
    .get(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getEmailConnectionDetails&companyid=${temp.companyid}&idproducts=${api_input}`,
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error.response.data.error);
    });
  return Response;
};

export const clearStorage = async (api_input) => {
  const userDetails = localStorage.getItem("userDetail");
  const temp = JSON.parse(userDetails);

  const Response = await axios
    .post(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=clearStorage&companyid=${temp.companyid}&beforeDate=${api_input}`,
      api_input,
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error.response.data.error);
    });
  return Response;
};
export const fetchDbCredentialDetails = async (api_input) => {
  const userDetails = localStorage.getItem("userDetail");
  const temp = JSON.parse(userDetails);

  const Response = await axios
    .get(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getDbConnectionDetails&companyid=${temp.companyid}&idproducts=${api_input}`,
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error.response.data.error);
    });
  return Response;
};
export const fetchUserDetails = async () => {
  const userDetails = localStorage.getItem("userDetail");
  const temp = JSON.parse(userDetails);
  const Response = await axios
    .get(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=userStatus&companyid=${temp.companyid}`,
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log("fetch user details error", error.response.data.error);
    });
  return Response;
};

export const getUserApproved = async (id) => {
  const userDetails = localStorage.getItem("userDetail");
  const temp = JSON.parse(userDetails);
  const Response = await axios
    .get(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=authorizedUser&companyid=${temp.companyid}&iduserprofile=${id}`,
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log("get approved api user", error.response.data.error);
    });
  return Response;
};
export const getuserReset = async (id) => {
  const userDetails = localStorage.getItem("userDetail");
  const temp = JSON.parse(userDetails);
  const Response = await axios
    .get(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=resetStatus&companyid=${temp.companyid}&iduserprofile=${id}`,
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log("reset error", error.response.data.error);
    });
  return Response;
};
export const getStaticIntegrations = async () => {
  const userDetails = localStorage.getItem("userDetail");
  const temp = JSON.parse(userDetails);
  const Response = await axios
    .get(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getStaticIntegrations&companyid=${temp.companyid}`,
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error.response.data.error);
    });
  return Response;
};
export const setLLmdetails = async (model, edit) => {
  const userDetails = localStorage.getItem("userDetail");
  const temp = JSON.parse(userDetails);
  const payload = {
    action: "setLLM",
    companyid: temp.companyid,
    ...model,
    edit: edit,
  };
  const queryString = new URLSearchParams(payload).toString();
  const Response = await axios
    .get(`${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?${queryString}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error.response.data.error);
    });
  return Response;
};
export const companySetting = async () => {
  const userDetails = localStorage.getItem("userDetail");
  const temp = JSON.parse(userDetails);
  const payload = {
    action: "companydetails",
    companyid: temp.companyid,
  };
  const queryString = new URLSearchParams(payload).toString();

  try {
  const response = await axios.get(`${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?${queryString}`);
    return response;
  } catch (error) {
    console.error(error.response?.data?.error || error.message);
    return null;
  }
};
export const getCompanyDeviceListDetails = async () => {
  const temp = getUserDetails();
  const payload = {
    action: "getCompanyDeviceListDetails",
    companyid: temp.companyid,
  };
  const queryString = new URLSearchParams(payload).toString();

  const response = await axios.get(`${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?${queryString}`);
  return response.data;
};
export const updateCompanyDeviceList = async (deviceList) => {
  const temp = getUserDetails();
  const payload = {
    action: "updateCompanyDeviceList",
    companyid: temp.companyid,
  };
  const queryString = new URLSearchParams(payload).toString();

  const response = await axios.post(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?${queryString}`,
    { deviceList },
  );
  return response.data;
};
export const getLLmsetup = async () => {
  const userDetails = localStorage.getItem("userDetail");
  const temp = JSON.parse(userDetails);

  // Build base payload
  const payload = {
    action: "getLLMsetup",
    companyid: temp.companyid,
  };

  // Convert to query string
  const queryString = new URLSearchParams(payload).toString();

  try {
  const response = await axios.get(`${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?${queryString}`);
    return response;
  } catch (error) {
    console.error(error.response?.data?.error || error.message);
    return null;
  }
};

export const getIntegrations = async (product, name) => {
  const userDetails = localStorage.getItem("userDetail");
  const temp = JSON.parse(userDetails);
  const Response = await axios
    .get(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getIntegrations&companyid=${temp.companyid}&productid=${product}&name=${name}`,
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error.response.data.error);
    });
  return Response;
};
export const addIntegration = async (product, intName, adminprop) => {
  const userDetails = localStorage.getItem("userDetail");
  const temp = JSON.parse(userDetails);
  const Response = await axios
    .get(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=addIntegration&companyid=${temp.companyid}&productid=${product}&intname=${intName}&adminprop=${adminprop}`,
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error.response.data.error);
    });
  return Response;
};
export const deleteIntegrations = async (intid) => {
  const userDetails = localStorage.getItem("userDetail");
  const temp = JSON.parse(userDetails);
  const Response = await axios
    .post(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=deleteIntegrations&companyid=${temp.companyid}&intid=${intid}`,
      intid,
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error.response.intid.error);
    });
  return Response;
};

export const getUSerRoles = async () => {
  const userDetails = localStorage.getItem("userDetail");
  const temp = JSON.parse(userDetails);
  const Response = await axios
    .get(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getUSerRoles&companyid=${temp.companyid}`,
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
    });
  return Response;
};
export const updateUserType = async (userid, roleid) => {
  const userDetails = localStorage.getItem("userDetail");
  const temp = JSON.parse(userDetails);
  const Response = await axios
    .get(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=UpdateUSerRole&companyid=${temp.companyid}&userid=${userid}&roleid=${roleid}`,
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
    });
  return Response;
};

export const updateModulePerm = async (moduleid, roleid, perm) => {
  const userDetails = localStorage.getItem("userDetail");
  const temp = JSON.parse(userDetails);
  const Response = await axios
    .get(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=updateModulePermission&companyid=${temp.companyid}&moduleid=${moduleid}&roleid=${roleid}&permission=${perm}`,
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
    });
  return Response;
};

export const getModulePermissions = async (modid) => {
  const userDetails = localStorage.getItem("userDetail");
  const temp = JSON.parse(userDetails);
  const Response = await axios
    .get(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getModulePermission&companyid=${temp.companyid}&moduleid=${modid}`,
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
    });
  return Response;
};
